/* eslint-disable unicorn/no-negated-condition */
/* eslint-disable unicorn/prefer-number-properties */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable prettier/prettier */
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import {
  AbuseDetailsLevel1VariantKeys,
  AbuseDetailsLevel2VariantKeys,
  AbuseDetailsLevel3VariantKeys,
  AbuseDetailsLevel4VariantKeys,
  AbuseDetailsLevel5VariantKeys,
  ClaimNumber,
  EIncludeExcludeKeys,
  EIncludeExcludeValue,
  ExcludeAbuseDetailsKeys,
  LegalDetailsKeys,
  LegalDetailsPreparatorVariantsKey,
  StaticPropertyKey,
  YesNoVariantsKey,
} from '@bvi/api-interfaces/entity/case-property';

import { ISearchFormDataSchema } from '../types';

export const mapFormDataToSubmit = (data: ISearchFormDataSchema) => {
  const preparatorValue =
    data[LegalDetailsKeys.PREPARATOR] === YesNoVariantsKey.YES
      ? [LegalDetailsPreparatorVariantsKey.DENIED_ABUSE]
      : [
        LegalDetailsPreparatorVariantsKey.ADMITTED_ABUSE,
        LegalDetailsPreparatorVariantsKey.CONVICTED,
        LegalDetailsPreparatorVariantsKey.DECEASED_WHEN_ACCUSED,
        LegalDetailsPreparatorVariantsKey.OTHERWISE_DEEMED_GUILTY,
      ];
  const classActionValue =
    data[EIncludeExcludeKeys.CLASS_ACTION_NAME] === EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;
  const bankruptcyValue =
    data[EIncludeExcludeKeys.BANKRUPTCY_NAME] === EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;
  const compensationValue =
    data[EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME] ===
      EIncludeExcludeValue.YES
      ? EIncludeExcludeValue.YES
      : null;

  function enumValuesToIndexes(enumObj: any, values: string[]) {
    if (values.some((v: any) => !isNaN(Number(v)))) {
      return values
    }
    const arr = Object.values(enumObj);
    return values.map(value => {
      const index = arr.indexOf(value);
      return index !== -1 ? index + 1 : null;
    });

  }

  const result = {
    ...data,
    [ExcludeAbuseDetailsKeys.LEVEL_1]: data[ExcludeAbuseDetailsKeys.LEVEL_1] ? enumValuesToIndexes(
      AbuseDetailsLevel1VariantKeys,
      data[ExcludeAbuseDetailsKeys.LEVEL_1]) : null,

    [ExcludeAbuseDetailsKeys.LEVEL_2]: data[ExcludeAbuseDetailsKeys.LEVEL_2] ? enumValuesToIndexes(
      AbuseDetailsLevel2VariantKeys,
      data[ExcludeAbuseDetailsKeys.LEVEL_2]) : null,

    [ExcludeAbuseDetailsKeys.LEVEL_3]: data[ExcludeAbuseDetailsKeys.LEVEL_3] ? enumValuesToIndexes(
      AbuseDetailsLevel3VariantKeys,
      data[ExcludeAbuseDetailsKeys.LEVEL_3]) : null,

    [ExcludeAbuseDetailsKeys.LEVEL_4]: data[ExcludeAbuseDetailsKeys.LEVEL_4] ? enumValuesToIndexes(
      AbuseDetailsLevel4VariantKeys,
      data[ExcludeAbuseDetailsKeys.LEVEL_4]) : null,

    [ExcludeAbuseDetailsKeys.LEVEL_5]: data[ExcludeAbuseDetailsKeys.LEVEL_5] ? enumValuesToIndexes(
      AbuseDetailsLevel5VariantKeys,
      data[ExcludeAbuseDetailsKeys.LEVEL_5]) : null,


    [StaticPropertyKey.COUNTRY]: data[StaticPropertyKey.COUNTRY]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.REGION]: data[StaticPropertyKey.REGION]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.STATE]: data[StaticPropertyKey.STATE]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.ORGANIZATION]: data[StaticPropertyKey.ORGANIZATION]?.id,
    [StaticPropertyKey.DIOCESE]: data[StaticPropertyKey.DIOCESE]?.id,
    [StaticPropertyKey.ORGANIZATION_TYPE]: data[
      StaticPropertyKey.ORGANIZATION_TYPE
    ]?.map((item) => item.id),
    [StaticPropertyKey.EXCEPTION]: data[StaticPropertyKey.EXCEPTION]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.ORDER]: data[StaticPropertyKey.ORDER]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.LIABILITY_DEFENSES]: data[
      StaticPropertyKey.LIABILITY_DEFENSES
    ]?.map((item) => item.id),
    [LegalDetailsKeys.PREPARATOR]: data[LegalDetailsKeys.PREPARATOR]
      ? preparatorValue
      : null,
    [StaticPropertyKey.RESOLUTION_TYPE]: data[
      StaticPropertyKey.RESOLUTION_TYPE
    ]?.map((item) => item.id),
    [StaticPropertyKey.JOB_TITLE]: data[StaticPropertyKey.JOB_TITLE]?.map(
      (item) => item.id,
    ),
    [StaticPropertyKey.PERPETRATOR]: data[StaticPropertyKey.PERPETRATOR]?.map(
      (item) => item.id,
    ),
    [EIncludeExcludeKeys.CLASS_ACTION_NAME]: data[
      EIncludeExcludeKeys.CLASS_ACTION_NAME
    ]
      ? classActionValue
      : null,
    [EIncludeExcludeKeys.BANKRUPTCY_NAME]: data[
      EIncludeExcludeKeys.BANKRUPTCY_NAME
    ]
      ? bankruptcyValue
      : null,
    [EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME]: data[
      EIncludeExcludeKeys.COMPENSATION_REDRESS_NAME
    ]
      ? compensationValue
      : null,
    [ClaimNumber.NAME]: data[ClaimNumber.NAME] ?? null,
  };

  return omitBy(result, (property) => isNil(property));
};
